<landing-page-ui
    [userDialogView]="userDialogView$ | async"
    (userDialogViewEventEmitter)="userDialogViewEventEmitter($event)"
    (dialogOutsideClickEvent)="dialogOutsideClickEventEmitter()"></landing-page-ui>